import EditIcon from '@mui/icons-material/Edit';
import { IconButton, SxProps } from '@mui/material';

export interface EditButtonProps {
  onClick: () => void;
  sx?: SxProps;
  dataTestId?: string;
}

export const EditButton: React.FC<EditButtonProps> = ({ onClick, sx, dataTestId }) => {
  return (
    <IconButton onClick={onClick} sx={sx} data-testid={dataTestId}>
      <EditIcon />
    </IconButton>
  );
};
